import React from 'react';
import styled from 'styled-components';
import ProductGallery from '@catalogo/ui-americanas-desktop-product-gallery';
import Sku from '@catalogo/ui-americanas-mobile-sku';
import Badges from '@catalogo/ui-americanas-mobile-product-main-area/src/components/badges';
import BuyTogether from '@catalogo/ui-americanas-desktop-buy-together';
import BuyTogetherVip from '@catalogo/ui-americanas-mobile-buy-together-vip';
import SummaryProductDescription from '@catalogo/ui-americanas-desktop-summary-product-description';
import QnaAnchor from '@catalogo/ui-americanas-mobile-product-main-area/src/components/qna-anchor';
import { Rating } from '@catalogo/theme-rating-reviews';
import ProductConditions from '@catalogo/ui-americanas-mobile-product-conditions';
import NurslingWarning from '@catalogo/ui-americanas-mobile-nursling-warning';
import ProductDisclaimer from '@catalogo/ui-americanas-desktop-product-disclaimer';
import ShareAndWishlist from './share-and-wishlist';
import { AirConditionerInfo } from './air-conditioner-info';
import { PreSale } from './pre-sale';
import ReturnPolicy from './return-policy';
import ProductTitle from '../product-title';

export const ProductInfo = props => {
  const { currentSku, product, recData, breadcrumb, experiment, page, dispatchMetrics } = props;
  const rating = product?.rating;
  const BuyTogetherVipShelf = recData?.['item_page.combo_vip'];
  const description = product?.description || {};
  const isNurslingProduct = product?.compliance?.nursling;
  const productConditionsProps = {
    parsedQs: props?.parsedQs,
    history: props?.history,
    conditions: product?.skus,
    currentCondition: currentSku?.offers?.result?.[0]?.condition,
  };

  return (
    <Container>
      <StickyContainer>
        <ProductInfoContainer>
          <Cell>
            <ShareAndWishlist {...props} />
            <ProductGallery {...props} quantity={5} />
          </Cell>
          <Cell>
            <Title {...props} asDesktop />
            <WrapperRating>
              <Rating rating={rating} productId={product?.id} dispatchMetrics={dispatchMetrics} />
              <QnaAnchor
                breadcrumb={breadcrumb}
                components={recData}
                product={product}
                cache={true}
                currentSku={currentSku}
                isMobile={false}
              />
            </WrapperRating>
            <Badges currentSku={currentSku} product={product} />
            <PreSale product={product} />
            <AirConditionerInfo product={product} />
            <ProductDisclaimer {...props} />
            <SummaryProductDescription description={description} page={page} />
            {isNurslingProduct && <NurslingWarning />}
            <ProductConditions {...productConditionsProps} />
            <Sku {...props} experiment={experiment?.CAT_021_VARIACOES_SKU} />
            <Wrapper>
              <BuyTogetherVip shelf={BuyTogetherVipShelf} currentSku={currentSku} />
            </Wrapper>
            <ReturnPolicy currentSku={currentSku} />
          </Cell>
        </ProductInfoContainer>
        <BuyTogether
          currentSku={currentSku}
          publication={recData?.['item_page.combo']}
          product={product}
          categoryUrl={breadcrumb?.[0]?.url}
        />
      </StickyContainer>
    </Container>
  );
};

const Title = styled(ProductTitle)`
  word-wrap: anywhere;
  hyphens: auto;
`;

const Wrapper = styled.div`
  padding: 20px 0;
`;

const Cell = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 10px;
`;

const Container = styled.div`
  border-radius: 24px 0 0 0;
  background-color: #fff;
  margin-right: 10px;
  padding: 30px 15px;
`;

const ProductInfoContainer = styled.div`
  display: flex;
  flex: 1 1 0px;
  width: 850px;
`;

const StickyContainer = styled.div`
  position: sticky;
  z-index: 1;
  top: 20px;
  padding-bottom: 20px;
`;

const WrapperRating = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
`;

export default ProductInfo;
